/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_Involvement_QuestionInputs */

const en_faq_involvement_question = /** @type {(inputs: Faq_Involvement_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How involved does our team need to be?`)
};

const lv_faq_involvement_question = /** @type {(inputs: Faq_Involvement_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cik lielā mērā jāiesaistās mūsu komandai?`)
};

/**
* | output |
* | --- |
* | "How involved does our team need to be?" |
*
* @param {Faq_Involvement_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_involvement_question = /** @type {((inputs?: Faq_Involvement_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_Involvement_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_involvement_question(inputs)
	return en_faq_involvement_question(inputs)
});